export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export function toggleAlert(message, error) {
  return { message, error, type: TOGGLE_ALERT };
}

export const SHOW_OVERLAY_FILTERS = 'SHOW_OVERLAY_FILTERS';
export function showOverlayFilters() {
  return ({ type: SHOW_OVERLAY_FILTERS });
}

export const HIDE_OVERLAY_FILTERS = 'HIDE_OVERLAY_FILTERS';
export function hideOverlayFilters() {
  return ({ type: HIDE_OVERLAY_FILTERS });
}
